(function () {
  'use strict';

  angular.module('app').component('productCostsAndPrices', productCostsAndPrices());

  function productCostsAndPrices() {
    return {
      bindings: {
        product: '<',
        productType: '<',
        seasonSelected: '<',
        zones: '<',
        showCosts: '<',
        showPrices: '<',
        applyPickupCostsAndPrices: '<',
        onProductCostsAndPricesSaved: '&',
        getAssociatedProvidersOnSave: '<',
      },
      controller: ProductCostsAndPricesComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/costs-and-prices/components/product-costs-and-prices/product-costs-and-prices.component.html',
    };
  }

  ProductCostsAndPricesComponent.$inject = [
    'CONFIGURATIONS',
    '$location',
    'CostsAndPricesService',
    'PriceListService',
    'ProviderService',

    // Angular downgraded service
    'paxRangeService',
  ];

  function ProductCostsAndPricesComponent(
    config,
    $location,
    CostsAndPricesService,
    PriceListService,
    ProviderService,

    // Angular downgraded service
    paxRangeService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.dateDisplay = config.DATE_DISPLAY_SHORT;
    vm.search = {};

    vm.$onInit = function () {
      // Initializers
      getPriceLists();
      getPaxRanges();
    };

    vm.$onChanges = function (changes) {
      if (changes.product || changes.seasonSelected) {
        if (changes.product) {
          setAssociatedProviders();

          vm.zonesByCosts = angular.copy(vm.zones); // !important
          vm.zonesByPrices = angular.copy(vm.zones); // !important
        }

        if (vm.priceListByProvidersSelected || vm.priceListByClientsSelected) {
          searchCostsAndPrices();
        }
      }
    };

    // public methods
    // -----------------------
    vm.openPriceListsModal = function () {
      let successCallback = function () {
        getPriceLists();
      };

      PriceListService.openPriceListsModal(successCallback);
    };

    vm.addAssociatedProvidersToProduct = function () {
      $location.path(`/${vm.productType}/${vm.product.id}`).search({ activeTab: 1 });
    };

    vm.selectPriceListByProviders = function (priceList) {
      if (vm.priceListByProvidersSelected && vm.priceListByProvidersSelected.id === priceList.id)
        return;

      vm.priceListByProvidersSelected = priceList;

      if (vm.applyPickupCostsAndPrices) {
        searchProductPickupCosts();
      }

      searchProductCosts();
    };

    vm.selectProvider = function (provider) {
      if (vm.providerSelected && vm.providerSelected.id === provider.id) return;

      vm.providerSelected = provider;

      if (vm.applyPickupCostsAndPrices) {
        searchProductPickupCosts();
      }

      searchProductCosts();
    };

    vm.selectPriceListByClients = function (priceList) {
      if (vm.priceListByClientsSelected && vm.priceListByClientsSelected.id === priceList.id)
        return;

      vm.priceListByClientsSelected = priceList;

      if (vm.applyPickupCostsAndPrices) {
        searchProductPickupPrices();
      }

      searchProductPrices();
    };

    vm.selectProductCostsAndPrices = function (type) {
      // vm.searchCostsBy  = 'costs';
      // vm.searchPricesBy = 'prices';
      if (type === 'costs') {
        vm.searchCostsBy = 'costs';
      } else {
        vm.searchPricesBy = 'prices';
      }
    };

    vm.selectProductPickupCostsAndPrices = function (type) {
      // vm.searchCostsBy  = 'pickup_costs';
      // vm.searchPricesBy = 'pickup_prices';
      if (type === 'pickup_costs') {
        vm.searchCostsBy = 'pickup_costs';
      } else {
        vm.searchPricesBy = 'pickup_prices';
      }
    };

    vm.onProductCostsSaved = function (dataObj) {
      vm.isProductCostsUpToDate = true;

      let obj = vm.getAssociatedProvidersOnSave ? { associated_providers: dataObj } : {};

      vm.onProductCostsAndPricesSaved(obj);
    };

    vm.onProductCostsCanceled = function () {};

    vm.onProductPickupCostsSaved = function () {
      vm.productPickupCostsLastUpdatedAt = true;
      // vm.onProductCostsAndPricesSaved();
    };

    vm.onProductPickupCostsCanceled = function () {};

    vm.onProductPricesSaved = function () {
      vm.isProductPricesUpToDate = true;
      // vm.onProductCostsAndPricesSaved();
    };

    vm.onProductPricesCanceled = function () {};

    vm.onProductPickupPricesSaved = function () {
      vm.productPickupPricesLastUpdatedAt = true;
      // vm.onProductCostsAndPricesSaved();
    };

    vm.onProductPickupPricesCanceled = function () {};

    // private methods
    // -----------------------
    function getPriceLists() {
      let params = {
        get: 'active',
        skip_check_role: true,
      };

      vm.loadingPriceLists = true;
      PriceListService.getPriceLists(params).then(function (data) {
        vm.priceListsByProviders = data.items.filter(
          (priceList) => priceList.contact_type === 'provider'
        );
        vm.priceListByProvidersSelected = vm.priceListsByProviders.find(
          (priceList) => priceList.is_default
        );
        vm.search.price_list_id_by_provider = vm.priceListByProvidersSelected.id;

        vm.priceListsByClients = data.items.filter(
          (priceList) => priceList.contact_type === 'client'
        );
        vm.priceListByClientsSelected = vm.priceListsByClients.find(
          (priceList) => priceList.is_default
        );
        vm.search.price_list_id_by_client = vm.priceListByClientsSelected.id;

        vm.loadingPriceLists = false;

        searchCostsAndPrices();
      });
    }

    function getPaxRanges() {
      let params = {
        get: 'active',
        skip_check_role: true,
      };

      paxRangeService.getPaxRanges(params).subscribe((response) => {
        // vm.paxRanges = PaxRangeService.items.map((paxRange) => ({ label: paxRange.name, ...paxRange }));
        vm.paxRanges = response;

        vm.paxRangesByCosts = angular.copy(vm.paxRanges); // !important
        vm.paxRangesByPrices = angular.copy(vm.paxRanges); // !important
      });
    }

    function searchCostsAndPrices() {
      if (vm.applyPickupCostsAndPrices) {
        searchProductPickupCosts();
        searchProductPickupPrices();
      }

      searchProductCosts();
      searchProductPrices();
    }

    // ---- PRODUCT COSTS

    function setAssociatedProviders() {
      vm.associatedProviders = ProviderService.setAssociatedProviders(
        vm.product.associated_providers,
        true
      );

      if (vm.associatedProviders.length > 0) {
        // Autoselect default provider
        vm.providerSelected = vm.associatedProviders.find(
          (associatedProvider) => associatedProvider.id === vm.product.default_provider_id
        );

        if (vm.providerSelected) {
          vm.search.provider_id = vm.providerSelected.id;
        }
      } else {
        vm.search.provider_id = null;
      }
    }

    function searchProductCosts() {
      if (!vm.priceListByProvidersSelected || !vm.providerSelected) return;

      vm.searchCostsFormEvaluated = true;

      vm.searchCostsBy = 'costs';

      let filterCriteria = {
        by_season: vm.seasonSelected.id,
        by_price_list: vm.priceListByProvidersSelected.id,
        by_provider_id: vm.providerSelected.id,
      };

      vm.productCosts = null;
      vm.productPickupCosts = null;

      vm.loadingProductCosts = true;
      CostsAndPricesService.searchProductCosts(vm.productType, vm.product, filterCriteria).then(
        function (data) {
          vm.productCosts = data;

          vm.isProductCostsUpToDate = data.length > 0 ? true : false;

          vm.loadingProductCosts = false;
        }
      );
    }

    function searchProductPickupCosts() {
      if (!vm.priceListByProvidersSelected || !vm.providerSelected) return;

      vm.searchCostsBy = 'pickup_costs';

      let filterCriteria = {
        by_season: vm.seasonSelected.id,
        by_price_list: vm.priceListByProvidersSelected.id,
        by_provider_id: vm.providerSelected.id,
      };

      vm.productPickupCosts = null;

      vm.loadingProductPickupCosts = true;
      CostsAndPricesService.searchProductPickupCosts(
        vm.productType,
        vm.product,
        filterCriteria
      ).then(function (data) {
        vm.productPickupCosts = data;

        vm.productPickupCostsLastUpdatedAt = data.length > 0 ? true : false;

        vm.loadingProductPickupCosts = false;
      });
    }

    // ---- PRODUCT PRICES

    function searchProductPrices() {
      if (!vm.priceListByClientsSelected) return;

      vm.searchPricesFormEvaluated = true;

      vm.searchPricesBy = 'prices';

      let filterCriteria = {
        by_season: vm.seasonSelected.id,
        by_price_list: vm.priceListByClientsSelected.id,
      };

      vm.productPrices = null;
      vm.productPickupPrices = null;

      vm.loadingProductPrices = true;
      CostsAndPricesService.searchProductPrices(vm.productType, vm.product, filterCriteria).then(
        function (data) {
          vm.productPrices = data;

          vm.isProductPricesUpToDate = data.length > 0 ? true : false;

          vm.loadingProductPrices = false;
        }
      );
    }

    function searchProductPickupPrices() {
      if (!vm.priceListByClientsSelected) return;

      vm.searchPricesBy = 'pickup_prices';

      let filterCriteria = {
        by_season: vm.seasonSelected.id,
        by_price_list: vm.priceListByClientsSelected.id,
      };

      vm.productPickupPrices = null;

      vm.loadingProductPickupPrices = true;
      CostsAndPricesService.searchProductPickupPrices(
        vm.productType,
        vm.product,
        filterCriteria
      ).then(function (data) {
        vm.productPickupPrices = data;

        vm.productPickupPricesLastUpdatedAt = data.length > 0 ? true : false;

        vm.loadingProductPickupPrices = false;
      });
    }
  }
})();
